/* eslint-disable array-callback-return */

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import {
    Box, FormControlLabel, Switch, TableRow, TableCell, Checkbox, Button, TextField
} from "@mui/material";
import { Col, Image, Row, Space, Modal } from "antd";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import MainHeader from "../../../../Shared/components/Header";
import { Link, useParams, NavLink } from "react-router-dom";
import usePrevious from "../../../../Shared/components/Previous";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard.js";
import crudActions from "../../../../CRUD/redux/actions";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import TickIcon from "../../../../../assets/images/icon_actions/Tick Mark.svg";
import PrimaryTable from "../../../../Shared/components/PrimaryTable";
import { featurePermisionHead, componentPermisionHead, clientTaggingHead } from "../../../../../config/constant";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import ComponentTable from './ComponentTable';
import ClientTable from './ClientTable';
import actions from "../../redux/actions";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import globalAddressActions from "../../../../Admin/Home/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import { checkCRUDViewPermission, checkCRUDPermission, getColumnWidth } from "../../../../../helpers/utilities";
import { toast } from 'react-toastify';
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";

const RoleView = (props) => {
    const { readDetails, createDetails, createError, createLoader, deleteDetails, deleteError, editDetails, editError } = useSelector(state => state.crudReducer);
    const { featureDetails, featureComponentDetails, componentDetails } = useSelector(state => state.younoteAdminSecuritySetupReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { roleId } = useParams();
    const { history } = props;
    const [search, setSearch] = useState('');
    const [multiples, setMultiples] = useState(false);
    const [featurePermission, setFeaturePermission] = useState([]);
    const [value, setValue] = useState("Feature");
    const [visible, setVisible] = useState(false);
    const [clientVisible, setClientVisible] = useState(false);
    const [clientAddMore, setClientAddMore] = useState(false);
    const [componentVisible, setComponentVisible] = useState(false);
    const [showDetails, setShowDetails] = useState(true);
    const [tabSetting, setTabSetting] = useState('feature');
    const [errorComponentId, setErrorComponentId] = useState(false);
    const [selected, setSelected] = useState([]);

    const [errorFeatureId, setErrorFeatureId] = useState(false);
    const timeoutRef = useRef(null);
    const prevSearch = usePrevious(search);
    const prevReadDetails = usePrevious(readDetails);
    const prevCreateDetails = usePrevious(createDetails);
    const prevDeleteDetails = usePrevious(deleteDetails);
    const prevDeleteError = usePrevious(deleteError);
    const prevCreateError = usePrevious(createError);
    const [deleteAllModal, setDeleteAllModal] = useState(false);
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const dispatch = useDispatch();

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setShowDetails(false);
            setFeaturePermission(readDetails?.featurePermissions);
            searchFunction(search);
        }
    }, [readDetails]);

    const [form, setForm] = useState({
        featureId: "",
        create: false,
        view: false,
        edit: false,
        deletable: false,
        full: false,
        roleId: parseInt(roleId)
    });

    const loadTasks = useCallback(() => {
        dispatch({
            type: actions.FEATURE_DETAILS_START, filter: {
                order: "id asc"
            }
        });
        dispatch({
            type: actions.COMPONENT_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: actions.FEATURE_COMPONENT_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: globalAddressActions.BUSINESS_LIST_START, url: 'business', filter: {
                order: 'id  desc'
            }
        });
        dispatch({ type: crudActions.READ_DETAILS_START, id: roleId, url: "role" });
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    const handleRowClick = (id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    useEffect(() => {
        if (roleManagement !== '' && checkCRUDViewPermission('Security Roles', 'view', history, 'Younote Admin')) {
            loadTasks();
        }
    }, [roleManagement]);

    const handleOpen = (data = '') => {
        emptyState();
        emptyStateInput();
        if (data === 'client') {
            setClientVisible(true);
        } else {
            setVisible(true);
        }
    };

    const emptyState = () => {
        setErrorFeatureId(false);
        setErrorComponentId(false);
    }

    const changeComponentVisible = (data) => {
        setComponentVisible(data);
        setErrorComponentId(false);
    }


    const emptyStateInput = () => {
        setForm({
            ...form,
            featureId: "",
            create: false,
            view: false,
            edit: false,
            deletable: false,
            full: false
        });
    }

    const addFeature = (e) => {
        e.preventDefault();
        let emptyFeatureId = emptyValidation('Feature', form.featureId);
        emptyState();
        if (emptyFeatureId.isValid) {
            delete form.full;
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'featurePermissions',
                title: 'Feature Permissions',
                details: form
            });
        } else {
            if (emptyFeatureId.errors) {
                setErrorFeatureId(emptyFeatureId.errors);
            }
        }
    }



    const featureObject = () => {
        let a = featureDetails && featureDetails.filter(function (el) { return el.id === form.featureId });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    };

    const changeHandler = (e, name = '') => {

        if (name !== '') {
            setForm({
                ...form,
                [name]: e,
            });
        } else if (e.target.name === 'full') {
            if (e.target.checked) {
                setForm({
                    ...form,
                    'edit': true,
                    'view': true,
                    'create': true,
                    'deletable': true,
                    'full': true,
                });
            } else {
                setForm({
                    ...form,
                    'edit': false,
                    'view': false,
                    'create': false,
                    'deletable': false,
                    'full': false,
                });
            }
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value,
            });
        }
    }

    const handleClose = (data = '') => {
        setVisible(false);
        emptyStateInput();
        emptyState();
        if (data === 'client') {
            setClientVisible(false);
        } else {
            setVisible(false);
        }
    };

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            toast(createDetails);
            setVisible(false);
            setClientVisible(false);
            emptyStateInput();
            setShowDetails(true);
            dispatch({ type: crudActions.READ_DETAILS_START, id: roleId, url: "role" });
            if (clientAddMore) {
                setClientAddMore(false);
                setTimeout(function () {
                    setClientVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let text = createError.error.message;
            if (text.includes("ER_DUP_ENTRY")) {
                if (componentVisible) {
                    setErrorComponentId("Component already exits");
                } else {
                    setErrorFeatureId("Feature already exits");
                }
            }
        }
    }, [createDetails, createError]);

    const handleChangeTab = (data) => {
        setTabSetting(data);
    }

    const featureCustomDetails = () => {
        if (readDetails?.featurePermissions) {
            return featureDetails && featureDetails.filter((el) => {
                return readDetails?.featurePermissions && readDetails?.featurePermissions.every(f => f.featureId !== el.id);
            });
        } return featureDetails;
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(() => {
                timeoutRef.current = null;
                searchFunction(search);
            }, 500);
        }
    }, [search]);

    const searchFunction = (search) => {
        if (search === '') {
            setFeaturePermission(readDetails?.featurePermissions);
        } else {
            let a = readDetails?.featurePermissions?.filter((el) => {
                return (el?.feature?.featureName.match(new RegExp(search, "i")) || el?.feature?.module?.module.match(new RegExp(search, "i")))
            });
            setFeaturePermission(a);
        }
    }

    const handleClearAll = () => {
        setDeleteAllModal(true);
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            dispatch({ type: crudActions.READ_DETAILS_START, id: roleId, url: "role" });
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            toast.dismiss();
            toast.error(editError.error.message);
        }
    }, [editDetails, editError]);

    const onDeleteAllPopup = () => {
        selected.map((a, i) => {
            dispatch({
                type: crudActions.DELETE_DETAILS_START,
                url: 'featurePermissions',
                title: 'Feature Permissions',
                id: a
            });
        });
        setSelected([]);
        setMultiples(false);
        setDeleteAllModal(false);
    }


    useEffect(() => {
        if (prevDeleteDetails !== undefined && deleteDetails && prevDeleteDetails !== deleteDetails) {
            handleClose(false);
            toast.dismiss();
            toast.error(deleteDetails);
            dispatch({ type: crudActions.READ_DETAILS_START, id: roleId, url: "role" });
        } else if (prevDeleteError !== undefined && deleteError && prevDeleteError !== deleteError) {
            handleClose(false);
            toast.dismiss();
            toast.error(deleteError.error.message);
        }
    }, [deleteDetails, deleteError]);

    const isSelected = (name) => selected.indexOf(name) !== -1;

    const handleGlobalRole = () => {
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: 'role',
            title: 'Role',
            id: roleId,
            details: { globalRole: !readDetails.globalRole }
        });
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props}
                cls={'newImg'}
                img={SettingsImg}
                title={'Younote Admin'}
                links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Security Roles', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Security Roles'}
                    customClass={classes.customerSettlement}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                        <TextField autoComplete='one-time-code'
                                            placeholder='Search'
                                            type='search'
                                            className={classes.comInput}
                                            required
                                            variant={'standard'}
                                            onChange={(e) => setSearch(e.target.value)}
                                            fullWidth
                                            onFocus={() => setIconAnimation(true)}
                                            onBlur={() => setIconAnimation(false)}
                                        />
                                        <Image
                                            src={SearchIcon}
                                            preview={false}
                                        />
                                    </div>
                                </Col>
                                <Col style={{ paddingLeft: '10px' }} xxl={3} xl={3} lg={3} md={3} sm={3} xs={12}><span className={classes.bold}>{readDetails?.name}</span></Col>
                                <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={12}>
                                    {
                                        showDetails === false && readDetails &&
                                        <FormControlLabel
                                            label="Available for All Clients"
                                            labelPlacement="end"
                                            name={"globalRole"}
                                            onChange={() => handleGlobalRole()}
                                            className={clsx(classes.switchAlignfont14, classes.switchAlign, classes.availableClients, classes.bold)}
                                            control={
                                                <Switch
                                                    className={clsx(classes.customSwitch)}
                                                    size="small" name="" checked={readDetails?.globalRole} />
                                            }
                                        />
                                    }
                                </Col>
                                <Col xxl={10} xl={9} lg={8} md={6} sm={3} xs={24} className={clsx(classes.textAlignRight, classes.removeUnderline)}>
                                    <Space size={[20, 20]} direction="horizontal" align="center">
                                        {
                                            roleManagement !== '' && checkCRUDPermission('Security Roles', 'edit', 'Younote Admin') && <>
                                                {
                                                    tabSetting === 'client' ? (
                                                        <NavLink
                                                            to="#"
                                                            onClick={() => handleOpen('client')}
                                                            className={clsx(classes.customLink, classes.disInline, classes.cursor)}
                                                        >
                                                            <Image
                                                                src={AddIcon}
                                                                preview={false}
                                                                className={clsx(classes.antImage)}
                                                            /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Client</span>
                                                        </NavLink>
                                                    ) : (
                                                        <>
                                                            <NavLink
                                                                to="#"
                                                                onClick={() => handleOpen()}
                                                                className={clsx(classes.customLink, classes.disInline, classes.cursor)}>
                                                                <Image
                                                                    src={AddIcon}
                                                                    preview={false}
                                                                    className={clsx(classes.antImage)}
                                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Feature</span>
                                                            </NavLink>
                                                            {
                                                                selected?.length > 0 ?
                                                                    <NavLink
                                                                        to="#"
                                                                        onClick={() => handleClearAll()}
                                                                        className={clsx(classes.AddMoreBtn, classes.marginRight0)}>
                                                                        Delete All
                                                                    </NavLink> : <NavLink
                                                                        to="#"
                                                                        onClick={() => setMultiples(!multiples)}
                                                                        className={clsx(classes.AddMoreBtn, classes.marginRight0)}>
                                                                        {
                                                                            multiples ? 'Select' : 'Delete All'
                                                                        }
                                                                    </NavLink>
                                                            }
                                                        </>
                                                    )
                                                }
                                            </>
                                        }
                                        {
                                            roleManagement !== '' && checkCRUDPermission('Security Roles', 'edit', 'Younote Admin') &&
                                            <Link to={`/younote-admin/security-setup/security-roles/${roleId}/edit`} className={clsx(classes.AddMoreBtn, classes.marginRight0)}>Edit</Link>
                                        }
                                    </Space>
                                </Col>
                            </Row>
                            <TabContext value={value}>
                                <Box className={classes.tabDesign}>
                                    <TabList onChange={handleChange} >
                                        <Tab
                                            className={classes.Bordertab_1}
                                            onClick={() => handleChangeTab('feature')}
                                            label="Feature Permissions" value={"Feature"} />
                                        <Tab className={classes.Bordertab_2}
                                            onClick={() => handleChangeTab('component')}
                                            label="Component Permissions" value={"Component"} />
                                        <Tab className={classes.Bordertab_2}
                                            onClick={() => handleChangeTab('client')}
                                            label="Client Tagging" value={"Client"} />
                                    </TabList>
                                </Box>
                                <TabPanel value={"Feature"}>
                                    <Row className={clsx(classes.scrollParent)}>
                                        <Col span={24}>
                                            <Row className={clsx(classes.customRow, classes.customRowRoles, classes.notificationTable, { [classes.multiples]: multiples })}>
                                                <CustomInfiniteScroll
                                                    loadMore={true}
                                                    loadMoreContent={false}
                                                    heads={featurePermisionHead}
                                                    width={true} details={featurePermission}
                                                    selected={selected}
                                                    onSelected={(value) => setSelected(value)}
                                                    component={
                                                        <>
                                                            {
                                                                showDetails || featurePermission === '' ? (
                                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                        <TableCell style={{ textAlign: "center" }} colSpan={featurePermisionHead.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                                                    </TableRow>
                                                                ) : (
                                                                    <React.Fragment>
                                                                        {
                                                                            featurePermission && featurePermission?.length > 0 ? featurePermission?.map((data, i) => (
                                                                                <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={classes.scrollParentIcons}>
                                                                                    <TableCell className={clsx('checkbox', classes.tablealign)} padding="checkbox"><Checkbox onClick={() => handleRowClick(data.id)} color="primary" checked={isSelected(data.id)} /></TableCell>
                                                                                    <TableCell style={{ width: getColumnWidth(featurePermisionHead, 1) }}><span style={{ width: getColumnWidth(featurePermisionHead, 1) }}>{data?.feature?.featureName}</span></TableCell>
                                                                                    <TableCell style={{ width: getColumnWidth(featurePermisionHead, 2) }}><span style={{ width: getColumnWidth(featurePermisionHead, 1) }}>{data?.feature?.module?.module}</span></TableCell>
                                                                                    <TableCell style={{ width: getColumnWidth(featurePermisionHead, 3) }}>{data?.create && <Image src={TickIcon} preview={false} />}</TableCell>
                                                                                    <TableCell style={{ width: getColumnWidth(featurePermisionHead, 4) }}>{data?.view && <Image src={TickIcon} preview={false} />}</TableCell>
                                                                                    <TableCell style={{ width: getColumnWidth(featurePermisionHead, 5) }}>{data?.edit && <Image src={TickIcon} preview={false} />}</TableCell>
                                                                                    <TableCell style={{ width: getColumnWidth(featurePermisionHead, 6) }} className={classes.textAlignLeft}>{data?.deletable && <Image src={TickIcon} preview={false} />}</TableCell>
                                                                                </TableRow>
                                                                            )) : (
                                                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                                    <TableCell className={classes.textAlignCenter} colSpan={featurePermisionHead.length}>
                                                                                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No Feauture Permission Added Here'}</p>
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            )
                                                                        }
                                                                    </React.Fragment>
                                                                )
                                                            }
                                                        </>
                                                    }
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </TabPanel>
                                <TabPanel value={"Component"}>
                                    <Row className={clsx(classes.scrollParent)}>
                                        <Col span={24}>
                                            <Row className={clsx(classes.customRow)}>
                                                <PrimaryTable
                                                    heads={componentPermisionHead}
                                                    width={true}
                                                    component={
                                                        <ComponentTable
                                                            type="view"
                                                            emptyState={() => emptyState()}
                                                            showDetails={showDetails}
                                                            componentPermisionHead={componentPermisionHead}
                                                            checkErrorComponentId={errorComponentId}
                                                            rows={featurePermission}
                                                            loadTasks={() => dispatch({ type: crudActions.READ_DETAILS_START, id: roleId, url: "role" })}
                                                            featureComponentDetails={featureComponentDetails}
                                                            componentDetails={componentDetails}
                                                            component={readDetails?.componentPermissions}
                                                            roleId={roleId}
                                                            roleManagement={roleManagement}
                                                            changeComponentVisible={(data) => { changeComponentVisible(data) }}
                                                        />
                                                    }
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </TabPanel>
                                <TabPanel value={"Client"}>
                                    <Row className={clsx(classes.scrollParent)}>
                                        <Col span={24}>
                                            <Row className={clsx(classes.customRow)}>
                                                <PrimaryTable
                                                    heads={clientTaggingHead}
                                                    width={true}
                                                    component={
                                                        <ClientTable
                                                            heads={clientTaggingHead}
                                                            visible={clientVisible}
                                                            loadTasks={() => { setShowDetails(true); dispatch({ type: crudActions.READ_DETAILS_START, id: roleId, url: "role" }) }}
                                                            handleClientOpen={(data) => handleOpen(data)}
                                                            handleClientClose={(data) => handleClose(data)}
                                                            rows={readDetails?.roleClients}
                                                            showDetails={showDetails}
                                                            roleId={roleId}
                                                            roleManagement={roleManagement}
                                                            clientAddMore={() => { setClientAddMore(true) }}
                                                        />
                                                    }
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </TabPanel>
                            </TabContext>
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={'Add Feature'}
                    className={classes.closeBackGround}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => addFeature(e)}
                        >
                            <div className={classes.customFormFlex}>
                                <AutoCompleteComponent
                                    name={["Feature ", <span key={"Feature"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'featureName', 'name': 'Name' }]}
                                    details={featureCustomDetails()}
                                    parentValue={featureObject()}
                                    onChange={(data) => changeHandler(data.id, 'featureId')}
                                    position={"bottom"}
                                    parentError={errorFeatureId}
                                />
                                <div className={clsx(classes.margin30t, classes.feautureCheckboxes)}>
                                    <Row>
                                        <Col span={5}>View</Col>
                                        <Col span={5}>Edit</Col>
                                        <Col span={5}>Create</Col>
                                        <Col span={6}>Delete</Col>
                                        <Col span={2} className={clsx(classes.textAlignRight)}>Full</Col>
                                    </Row>
                                    <Row className={clsx(classes.feautureCheckboxesRow)}>
                                        <Col span={5}>
                                            <Checkbox checked={form.view} name={"view"} onChange={(e) => changeHandler(e)} />
                                        </Col>
                                        <Col span={5}>
                                            <Checkbox checked={form.edit} name={"edit"} onChange={(e) => changeHandler(e)} />
                                        </Col>
                                        <Col span={5}>
                                            <Checkbox checked={form.create} name={"create"} onChange={(e) => changeHandler(e)} />
                                        </Col>
                                        <Col span={6}>
                                            <Checkbox checked={form.deletable} name={"deletable"} onChange={(e) => changeHandler(e)} />
                                        </Col>
                                        <Col span={2}>
                                            <FormControlLabel
                                                label=""
                                                labelPlacement="end"
                                                name={"full"}
                                                className={clsx(classes.switchAlignfont14, classes.switchAlign, classes.availableClients, classes.bold)}
                                                control={
                                                    <Switch
                                                        className={clsx(classes.customSwitch)}
                                                        size="small" name="full" onChange={(e) => changeHandler(e)} checked={form.full} />
                                                }
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                <Button
                                    key="add"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}

                                >Save</Button>
                            </div>
                        </Box>
                    }
                />
                <Modal
                    title={'Delete Confirmation'}
                    open={deleteAllModal}
                    onOk={() => setDeleteAllModal(false)}
                    onCancel={() => setDeleteAllModal(false)}
                    width={525}
                    className={clsx(classes.commonPopup, classes.deletePopup, classes.deleteNotificationPopup)}
                    // closeIcon={<CloseIcon />}
                    footer={
                        [
                            <Button
                                key="yes"
                                type='submit'
                                color='primary'
                                variant="contained"
                                className={clsx(classes.modalBtn)}
                                onClick={() => onDeleteAllPopup()}
                            >Yes</Button>,
                            <Button
                                key="no"
                                type='submit'
                                color='primary'
                                variant="contained"
                                className={clsx(classes.AddMoreBtn)}
                                onClick={() => setDeleteAllModal(false)}
                            >
                                No
                            </Button>,
                        ]}>
                    <p>The selected message will be deleted permanently, Do you want to continue?</p>
                </Modal>
            </div>
        </React.Fragment>
    )

}

export default RoleView;


